module.exports = __webpack_public_path__ + "static/media/(H)-Prata-03.aa4f6e28.jpg";